// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Main_componentWrapper__MlHVr","content":"Main_content__H5nTL","backToTop":"Main_backToTop__idEYl"};